
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import * as n from "@/types/notifications";
import EmailForHost from "@/components/Notifications/Types/Util/EmailForHost.vue";

@Component({
  components: {
    EmailForHost
  }
})
export default class FriendlyMultiError extends Vue {
  @Prop()
  value!: n.InternalServerErrorNotification | n.ForbiddenErrorNotification;
}
